"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convert = convert;
exports.default = immutableToJS;
exports.isImmutable = isImmutable;
exports.toJS = toJS;
exports.toJSDeep = toJSDeep;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isPlainObject2 = _interopRequireDefault(require("lodash/isPlainObject"));

var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));

var _memoize2 = _interopRequireDefault(require("lodash/memoize"));

var _immutable = require("immutable");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function isImmutable(obj) {
  return _immutable.Iterable.isIterable(obj);
}

function toJS(obj) {
  return obj.toJS();
}

var memoizedToJs = (0, _memoize2.default)(toJS);
memoizedToJs.Cache = new WeakMap();

function toJSDeep(obj) {
  /* eslint no-use-before-define: 0 */
  return (0, _mapValues2.default)(obj, memoizedConvert);
}

function convert(obj) {
  if (isImmutable(obj)) {
    return memoizedToJs(obj);
  } else if ((0, _isPlainObject2.default)(obj)) {
    return toJSDeep(obj);
  }

  return obj;
}

var memoizedConvert = (0, _memoize2.default)(convert);
memoizedConvert.Cache = new WeakMap();

function immutableToJS() {
  return function (createStore) {
    return function (reducer, initialState) {
      var store = createStore(reducer, initialState);
      return _objectSpread(_objectSpread({}, store), {}, {
        getState: function getState() {
          return toJSDeep(store.getState());
        }
      });
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/reduxMiddleware/immutableToJS.js
// module id = 4409
// module chunks = 25